(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["size-guide"] && !Shopify.designMode) return;
  try {
    document.getElementById('size-guide-modal').addEventListener('click', function(e) {
    if (e.target === this) this.close();
  });
  } catch(e) { console.error(e); }
})();

})();
